import React from "react";

import Chip from "@mui/material/Chip";

import { EnumValue } from "@fartherfinance/frontend/api/TaskWorkflows/Types";

import TaskStatusIcon from "../TaskStatusIcon/TaskStatusIcon";
import { toClassName } from "@src/multiCustodian/utils/to-class-name";

import styles from "./TaskStatusChip.module.css";

const mapTaskStatusToLabelV2 = (taskStatus: EnumValue) => {
  switch (taskStatus.id) {
    case "WAITING_ON_CLIENT":
      return "Client";

    case "WAITING_ON_ADVISOR":
      return "Advisor";

    case "WAITING_ON_THIRD_PARTY":
      return "Third-Party";

    case "WAITING_ON_CUSTODIAN":
      return "Custodian";

    default:
      return taskStatus.displayValue;
  }
};

interface TaskStatusChipProps {
  taskStatus: EnumValue;
}

const TaskStatusChip: React.FC<TaskStatusChipProps> = ({
  taskStatus,
}): JSX.Element => {
  const { id } = taskStatus;

  return (
    <Chip
      classes={{
        root: toClassName(styles.chip, {
          [styles.notStarted]: id === "NOT_STARTED",
          [styles.inProgress]: id === "IN_PROGRESS",
          [styles.waitingOn]: id.startsWith("WAITING_ON"),
          [styles.completed]: id === "COMPLETED",
          [styles.canceled]: id === "CANCELED",
        }),
        label: styles.chipLabel,
        icon: styles.chipIcon,
      }}
      variant="outlined"
      label={mapTaskStatusToLabelV2(taskStatus)}
      icon={<TaskStatusIcon taskStatus={id} />}
    />
  );
};

export default TaskStatusChip;
